import { useInfiniteQuery } from '@tanstack/react-query';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {
  text?: string;
};

type UnlistedCarsPage = {
  data: Car[];
  meta: {
    page: number;
    totalPages: number;
    totalCount: number;
  };
};

const fetchUnlistedCars = async ({
  pageParam,
  variables,
}: {
  pageParam: number;
  variables: Variables;
}) => {
  try {
    let params: Record<string, any> = {
      page: pageParam,
    };

    if (variables.text) {
      params.text = variables.text;
    }

    const response = await client.get('v2/internal/partners/cars/unlisted', {
      params: { ...params },
    });

    return response.data;
  } catch (error) {
    console.error('fetchUnlistedCars error:', error);
    throw error;
  }
};

export const useUnlistedCars = (variables: Variables) => {
  return useInfiniteQuery({
    queryKey: ['internal/partners/cars/unlisted', variables],
    queryFn: ({ pageParam = 1 }) =>
      fetchUnlistedCars({
        pageParam,
        variables,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: UnlistedCarsPage) => {
      if (lastPage.meta.page >= lastPage.meta.totalPages) {
        return undefined;
      }
      return lastPage.meta.page + 1;
    },
  });
};
